import { OrganizationKeyName } from "../../../model/Organization";

export const UPDATE_PRODUCT_CATEGORY_ORDER_SUCCESS =
  "SHOP:UPDATE_PRODUCT_CATEGORY_ORDER_SUCCESS";

export const updateProductCategoryOrderSuccessAction = (
  organization: OrganizationKeyName
) => ({
  type: UPDATE_PRODUCT_CATEGORY_ORDER_SUCCESS as typeof UPDATE_PRODUCT_CATEGORY_ORDER_SUCCESS,
  organization,
});

export type UpdateProductCategoryOrderSuccessAction = ReturnType<
  typeof updateProductCategoryOrderSuccessAction
>;
